<template>
  <v-dialog fullscreen v-model="isOpened" @close="onCancel">
    <v-card >
      <v-toolbar color="primary">
        <v-toolbar-title>
          <span class="text-h5">
            장치 추가
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="onCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-text-field class="flex-0-0" v-model="searchWord" variant="filled" hide-details prepend-inner-icon="mdi-magnify"></v-text-field>
      <v-card-text class="device-list">
        <v-list style="margin: -4px;">
          <v-list-item
              :class="{active: selected.some(({id}) => id === device.id), 'ma-1': true}"
              rounded
              @click="() => onDevice(device)"
              v-for="device in filteredDevices">
            {{ device.name }}
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn
            variant="tonal" @click="onSelectAll">전체선택</v-btn>
        <v-spacer></v-spacer>
        <v-btn variant="tonal" @click="onOk">확인</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import {ref, computed, defineProps, watch} from "vue";
import {useAppStore} from "@/stores/app";

const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue']);

const appStore = useAppStore();

const isOpened = ref(true);
const searchWord = ref('');
const selected = ref(props.modelValue);

const filteredDevices = computed(() => appStore.devices.filter(device => {
  const search = searchWord.value.trim().toUpperCase();
  if (!search) return true;
  return device.name.trim().toUpperCase().includes(search);
}) || []);

const onDevice = device => {

  if (selected.value.some(({id}) => id === device.id))
    selected.value = selected.value.filter(({id}) => id !== device.id);
  else
    selected.value = [...selected.value, device];
};

const onSelectAll = () => {
  const unlisted = filteredDevices.value.filter(({id}) => !selected.value.some(device => device.id === id));
  if (0 < unlisted.length) {
    selected.value = [...selected.value, ...unlisted];
    return;
  }

  selected.value = selected.value.filter(({id}) => !filteredDevices.value.some(device => device.id === id));
};

const onCancel = () => {
  emit('update:modelValue', props.modelValue);
};

const onOk = () => {
  emit('update:modelValue', selected.value);
};

</script>

<style scoped>
.device-list {overflow-x: hidden;overflow-y: auto;}
.device-list .selected-row {background-color: #ff0000;}
</style>
